import { createContext, useContext } from 'react';
import { ActiveColorFilter, CampaignPlanPoi, TouchedPoint } from 'components/common/types/CampaignPlan.types';

export type { ActiveColorFilter, ActiveColorFilterType } from 'components/common/types/CampaignPlan.types';

export interface CampaignPlanFiltersContextValue {
  activeColorFilter: ActiveColorFilter | null;
  selectedPois: CampaignPlanPoi[];
  touchedPoints: TouchedPoint[];
}

export const CampaignPlanFiltersContext = createContext<CampaignPlanFiltersContextValue>({
  activeColorFilter: null,
  selectedPois: [],
  touchedPoints: [],
});

export const useCampaignPlanFiltersContext = (): CampaignPlanFiltersContextValue =>
  useContext(CampaignPlanFiltersContext);
